
import { AuthenticationResult } from "@azure/msal-browser";
import { AuthenticatedContext } from "@components/AuthorizationContext";

export enum MainLayoutActionType {
    INIT_AUTHENTICATION_CONTEXT,
    UPDATE_AUTHENTICATION_CONTEXT,
    UPDATE_TOKEN,
}

export interface MainLayoutState {
    authenticatedContext: AuthenticatedContext,
}

export interface MainLayoutStateAction {
    type: MainLayoutActionType;
    authenticatedContext?: AuthenticatedContext,
    apiTokenResult?: AuthenticationResult;
}

function mainLayoutReducer(state: MainLayoutState, action: MainLayoutStateAction) {
    switch (action.type) {
        case MainLayoutActionType.INIT_AUTHENTICATION_CONTEXT:
            return {
                ...state,
                authenticatedContext: action.authenticatedContext
            } as MainLayoutState;
        case MainLayoutActionType.UPDATE_AUTHENTICATION_CONTEXT:
            return {
                ...state,
                authenticatedContext: AuthenticatedContext.create({
                    ...state.authenticatedContext,
                    ...action.authenticatedContext
                })
            } as MainLayoutState;
        case MainLayoutActionType.UPDATE_TOKEN: {
            if (!action.apiTokenResult || state.authenticatedContext?.apiTokenResult?.accessToken === action.apiTokenResult?.accessToken) {
                return state;
            }

            return {
                ...state,
                authenticatedContext: AuthenticatedContext.create({
                    ...state.authenticatedContext,
                    apiTokenResult: action.apiTokenResult
                })
            } as MainLayoutState;
        }
    }
}

export default mainLayoutReducer;